import React from "react";

import classes from "./TogglerButton.module.css";

const TogglerButton = ({ isActive = true }) => {
  return (
    <div className={classes.container}>
      <div className={isActive ? `${classes.change}` : null}>
        <div className={classes.bar1}></div>
        <div className={classes.bar2}></div>
        <div className={classes.bar3}></div>
      </div>
    </div>
  );
};

export default TogglerButton;
